<template>
    <div>
<!--        <el-form-item label="产品" prop="product" :rules="[{required: true, message: '请选择产品'}]">-->
        <el-select :disabled="loading" v-model="query.product" clearable filterable style="width: 150px" placeholder="产品">
          <el-option v-for="(v, k) in product_query_map" :value="v" :label="k"></el-option>
        </el-select>
<!--        </el-form-item>-->
        <el-select :disabled="loading" v-model="query.category" clearable filterable style="width: 200px"
                   placeholder="分类">
            <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                       :value="c.key"></el-option>
        </el-select>
        <el-select :disabled="loading" v-model="query.module" clearable style="width: 150px" placeholder="模块">
            <el-option v-for="(v, k) in $root.image_module_enum" :label="v" :value="parseInt(k)"></el-option>
        </el-select>
        <el-select :disabled="loading" v-model="query.video" clearable style="width: 150px" placeholder="激励视频">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-select :disabled="loading" v-model="query.is_animated" clearable style="width: 150px" placeholder="是否动图">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
        </el-select>

        <el-select :disabled="loading" v-model="query.online" clearable style="width: 150px" placeholder="是否上线">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>

        <el-select :disabled="loading" v-model="query.null_category" clearable style="width: 120px" placeholder="是否空分类">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-select :disabled="loading" v-model="query.source" clearable @clear="formData.source = null" style="width: 120px" placeholder="来源">
          <el-option v-for="item in $root.sourceList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>

        <el-input v-model="query.id" placeholder="ID" @change="reload" style="width: 220px"></el-input>
        <date-range-picker v-model="query" start-placeholder="上线开始时间" end-placeholder="上线结束时间"
                           :disabled="loading" :disabledDate="disabledDate" clearable></date-range-picker>
        <el-button type="success" :loading="loading" @click="init">查询</el-button>
        <el-button type="primary" :loading="loading" @click="openDialog()">新建</el-button>
        <el-button type="primary" :loading="loading" @click="openBatchDialog()">批量上传</el-button>
        <el-button type="danger" :loading="loading" @click="batchDelete()">批量删除</el-button>
    </div>
    <el-table :data="data" v-loading="loading" style="margin-top: 10px" @selection-change="handleSelectionChange">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="ID" prop="id" width="250">
            <template #default="scope">
                <div>{{ scope.row.id }}</div>
                <div style="text-align: center">
                    <a :href="`${$root.cdn_url}/${scope.row.resource}`" target="_blank">查看原图</a>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="缩略图" prop="thumbnail" width="200">
            <template #default="scope">
                <el-image :src="`${$root.cdn_url}/${scope.row.thumbnail}`" lazy style="width: 180px"></el-image>
            </template>
        </el-table-column>
        <el-table-column label="状态" prop="source" width="100">
            <template #default="scope">
                    {{ scope.row.status ==='pending'? '上传中': scope.row.status ==='failed'? '上传失败' : '上传完成' }}
            </template>
        </el-table-column>
        <el-table-column label="来源" prop="source" width="100">
            <template #default="scope">
                {{ scope.row.source }}
            </template>
        </el-table-column>
        <el-table-column label="动图" prop="animation" width="200">
          <template #default="scope">
            <video v-if="scope.row.animation" :src="`${$root.cdn_url}/${scope.row.animation}`" controls muted
                   style="width: 180px"></video>
          </template>
        </el-table-column>
        <el-table-column label="模块" prop="module" width="100">
            <template #default="scope">
                {{ $root.image_module_enum[scope.row.module] }}
            </template>
        </el-table-column>
        <el-table-column label="产品" prop="product" width="150">
          <template #default="scope">
            <template v-for="key in scope.row.product">
              <template v-for="c in getProductList()">
                <el-tag v-if="c.key === key">{{ c.name}}</el-tag>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="平台" prop="platform" width="100">
        </el-table-column>
        <el-table-column label="分类" prop="categories" width="200">
            <template #default="scope">
                <template v-for="key in scope.row.categories">
                    <template v-for="c in category_list">
                        <el-tag v-if="c.key === key">{{ c.i18n_name.EN }}</el-tag>
                    </template>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="激励视频" prop="video" width="120">
            <template #default="scope">
                {{ scope.row.video ? '是' : '' }}
            </template>
        </el-table-column>
        <el-table-column label="上线时间" prop="online_date" width="150">
          <template #default="scope">
            <el-date-picker style="width: 120px" value-format="YYYY-MM-DD" v-model="scope.row.online_date"
                            @change="updateDate(scope.row)" :clearable="true"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
            <template #default="scope">
                <el-button size="small" :disabled="loading" @click="openDialog(scope.row)">编辑</el-button>
                <el-button size="small" type="danger" :disabled="loading" @click="remove(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchData"
                   :page-size="query.limit"></el-pagination>
    <el-dialog v-model="dialog_opened" :before-close="reset">
        <el-form :model="form" ref="form" label-width="100px">
            <el-form-item label="分类" prop="categories" :rules="[{required: true, message: '请选择分类'}]">
                <el-select v-model="form.categories" :disabled="loading" multiple filterable>
                    <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                               :value="c.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模块" prop="module">
                <el-radio-group v-model="form.module" :disabled="loading">
                    <el-radio v-for="(v, k) in $root.image_module_enum" :label="parseInt(k)">{{ v }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="激励视频" prop="video" :rules="[{required: true, message: '请选择是否激励视频'}]">
                <el-radio-group v-model="form.video" :disabled="loading">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </el-form-item>
               <el-form-item label="来源" prop="source">
                <el-select v-model="form.source" :disabled="loading" clearable>
                    <el-option v-for="item in $root.sourceList" :key="item.value" :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图片" prop="resource" :rules="[{required: true, message: '请上传图片'}]">
                <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleSuccess"
                           accept="image/*" :data="{prefix: 'origin'}" :onProgress="handleProgress" :disabled="loading"
                           :before-upload="beforeImageUpload"
                           :headers="{authorization: $root.authorization}">
                    <el-image v-if="form.resource" :src="`${$root.cdn_url}/${form.resource}`" lazy
                              style="width: 200px"></el-image>
                    <el-button size="small" v-else :loading="loading">上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="动图" prop="animation" :rules="[{required: false, message: '请上传动图'}]">
              <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleAnimationSuccess"
                         accept="video/mp4,.mp4" :data="{prefix: 'animations'}" :onProgress="handleProgress" :disabled="loading"
                         :before-upload="beforeAnimationUpload"
                         :headers="{authorization: $root.authorization}">
                <video v-if="form.animation" :src="`${$root.cdn_url}/${form.animation}`" controls muted
                       style="width: 200px"></video>
                <el-button size="small" v-else :loading="loading">上传 MP4</el-button>
              </el-upload>
              <div style="color: var(--el-text-color-secondary)">MP4，正方形，不超过 2MB</div>
            </el-form-item>
            <el-form-item label="所属产品" prop="product" :rules="[{required: true, message: '请选择产品'}]">
              <el-select v-model="form.product" filterable multiple :disabled="loading" style="width: 100%">
                <el-option v-for="c in getProductList()" :value="c.key" :label="c.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台" prop="platform">
              <el-select v-model="form.platform" clearable filterable placeholder="请选择平台" :disabled="loading" style="width: 140px; margin-left: 10px">
                <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包含国家" prop="include_country">
              <el-select v-model="form.include_country" filterable multiple :disabled="loading" style="width: 100%">
                <el-option v-for="c in $root.country_list" :value="c.code"
                           :label="c.en_name + ' (' + c.code + ')'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排除国家" prop="exclude_country">
              <el-select v-model="form.exclude_country" filterable multiple :disabled="loading" style="width: 100%">
                <el-option v-for="c in $root.country_list" :value="c.code"
                           :label="c.en_name + ' (' + c.code + ')'"></el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" text :loading="loading" @click="reset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
     <el-dialog v-model="batchDialog_opened" :before-close="batchReset">
        <el-form :model="batchForm" ref="batchForm" label-width="100px">
              <el-form-item label="上传压缩包" prop="file" :rules="[{required: true, message: '请上传压缩包'}]">
                <el-upload
                    class="upload-demo"
                    action="#"
                    :on-change="handleChange"
                    :on-remove="handleRemove"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    accept=".zip"
                    :auto-upload="false"
                    drag
                    >
                    <el-button type="primary">点击上传</el-button>
                    <div>只能上传zip文件，且不超过{{ maxSize }}MB</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="分类" prop="categories" :rules="[{required: true, message: '请选择分类'}]">
                <el-select v-model="batchForm.categories" :disabled="loading" multiple filterable>
                    <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                               :value="c.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模块" prop="module">
                <el-radio-group v-model="batchForm.module" :disabled="loading">
                    <el-radio v-for="(v, k) in $root.image_module_enum" :label="parseInt(k)">{{ v }}</el-radio>
                </el-radio-group>
            </el-form-item>
               <el-form-item label="来源" prop="source">
                <el-select v-model="batchForm.source" :disabled="loading" clearable>
                    <el-option v-for="item in $root.sourceList" :key="item.value" :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属产品" prop="product" :rules="[{required: true, message: '请选择产品'}]">
              <el-select v-model="batchForm.product" filterable multiple :disabled="loading" style="width: 100%">
                <el-option v-for="c in getProductList()" :value="c.key" :label="c.name"></el-option>
              </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" text :loading="loading" @click="batchReset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="batchSubmit">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import DateRangePicker from "../base/DateRangePicker";
import {update} from "../libs/utils";
import {getProduct, getProductList} from "../libs/app.ts";
import imageCompression from 'browser-image-compression';
import { unzipSync, zipSync } from 'fflate';


export default {
    name: "Index",
    components: {DateRangePicker},
    data() {
        return {
            loading: false, data: [], editing: null, total: 0, maxSize: 200, dialog_opened: false, batchDialog_opened: false, category_list: [],sourceList:[],
            product_query_map: {"classic": "classic_label", "countryside": "countryside", "无": 'no_label'},
            query: {
                category: null,
                source: null,
                module: null,
                start: null,
                end: null,
                skip: 0,
                limit: 50,
                video: null,
                is_animated: null,
                online: null,
                null_category: null,
                product: null,
            },
            form: {
                categories: [],
                module: 1,
                resource: null,
                source:null,
                video: false,
                online_date: null,
                include_country: [],
                exclude_country: [],
                platform: null,
                product: [],
                animation: null,
            },
            batchForm: {
                file: null,
                categories: [],
                module: 1,
                source: null,
                product: []
            },
            fileList:[],
            idList: [],
        }
    },
    methods: {
      getProductList,
        init() {
            this.query.skip = 0;
            this.loading = true;
            axios.all([
                axios.get(`/cms/v1/image`, {params: this.query}).then(res => {
                    this.data = res.data.data.imageList;
                    this.total = res.data.data.total;
                }),
                axios.get(`/cms/v1/category`).then(res => {
                    this.category_list = res.data.data.categoryList;
                })
            ]).then(_ => {
                this.loading = false;
            })
        },
        fetchData(page) {
            this.query.skip = (page - 1) * this.query.limit;
            this.loading = true;
            axios.get(`/cms/v1/image`, {params: this.query}).then(res => {
                this.data = res.data.data.imageList;
                this.total = res.data.data.total;
                this.loading = false;
            })
        },
        openDialog(item) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                this.editing = item;
                update(this.form, item);
            })
        },
        reset() {
            this.$refs.form.resetFields();
            this.dialog_opened = this.loading = false;
            this.editing = null;
            this.form.categories = [];
            this.form.source = null;
            this.form.include_country = [];
            this.form.exclude_country = [];
            this.form.platform = null
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.editing) {
                        axios.put(`/cms/v1/image/${this.editing.id}`, this.form).then(res => {
                            update(this.editing, res.data.data);
                            this.editing.product = res.data.data.product
                            this.reset();
                        })
                    } else {
                        axios.post(`/cms/v1/image`, this.form).then(res => {
                            this.data.unshift(res.data.data);
                            this.reset();
                        })
                    }
                }
            })
        },
        handleProgress() {
            this.loading = true;
        },
        async beforeImageUpload(file) {
            const valid = await this.validateImageResolution(file);
            if (!valid) {
                this.loading = false;
            }
            return valid;
        },
        async validateImageResolution(file) {
            if (!file || !file.type || !file.type.startsWith('image/')) {
                this.$message.error('只能上传图片文件');
                return false;
            }
            try {
                const { width, height } = await this.getImageDimensions(file);
                if (width !== 2048 || height !== 2048) {
                    this.$message.error(`图片分辨率必须为2048*2048，当前为${width}*${height}`);
                    return false;
                }
                return true;
            } catch (error) {
                this.$message.error('读取图片分辨率失败，请重新选择文件');
                return false;
            }
        },
        getImageDimensions(file) {
            return new Promise((resolve, reject) => {
                const objectUrl = URL.createObjectURL(file);
                const img = new Image();
                img.onload = () => {
                    resolve({ width: img.naturalWidth, height: img.naturalHeight });
                    URL.revokeObjectURL(objectUrl);
                };
                img.onerror = () => {
                    URL.revokeObjectURL(objectUrl);
                    reject(new Error('invalid image file'));
                };
                img.src = objectUrl;
            });
        },
        beforeAnimationUpload(file) {
            return this.validateAnimationFile(file, file.name).catch(error => {
                this.$message.error(error.message || '视频文件校验失败');
                return Promise.reject(error);
            });
        },
        validateAnimationFile(file, filename) {
            const isMp4 = filename.toLowerCase().endsWith('.mp4');
            if (!isMp4) {
                return Promise.reject(new Error(`文件 ${filename} 动图格式必须为 MP4`));
            }
            if (file.size > 2 * 1024 * 1024) {
                return Promise.reject(new Error(`文件 ${filename} 视频大小需控制在 2MB 以内`));
            }
            return this.getVideoDimensions(file).then(({ width, height }) => {
                if (width !== height) {
                    throw new Error(`文件 ${filename} 视频尺寸必须为正方形，当前为${width}×${height}`);
                }
                return true;
            }).catch(error => {
                if (error.message && error.message.startsWith('文件 ')) {
                    throw error;
                }
                throw new Error(`文件 ${filename} 无法读取视频文件`);
            });
        },
        getVideoDimensions(file) {
            return new Promise((resolve, reject) => {
                const objectUrl = URL.createObjectURL(file);
                const video = document.createElement('video');
                video.preload = 'metadata';
                video.onloadedmetadata = () => {
                    resolve({ width: video.videoWidth, height: video.videoHeight });
                    URL.revokeObjectURL(objectUrl);
                };
                video.onerror = () => {
                    URL.revokeObjectURL(objectUrl);
                    reject(new Error('invalid video file'));
                };
                video.src = objectUrl;
            });
        },
        handleSuccess(res) {
            this.form.resource = res.data.name;
            this.loading = false;
        },
        handleAnimationSuccess(res) {
          this.form.animation = res.data.name;
          this.loading = false;
        },
        updateDate(row) {
          this.loading = true;
          axios.put(`/cms/v1/online/image/${row.id}`, {product: getProduct().key, online_date: row.online_date}).then(_ => {
            this.loading = false;
          })
        },
        reload() {
          if (!this.query.id || this.query.id.length === 24) {
            this.query.skip = 0;
            this.page = 1;
            this.init();
          }
        },
        disabledDate(time) {
            return time.getTime() < 1630425600000
        },
        openBatchDialog(){
            this.batchDialog_opened = true;
        },
        batchReset(){
            this.$refs.batchForm.resetFields();
            this.batchDialog_opened = this.loading = false;
            this.batchForm.categories = [];
            this.batchForm.source = null;
            this.batchForm.module = 1;
            this.batchForm.product = [];
            this.batchForm.file = null;
            this.fileList = [];
        },
        batchSubmit(){
            if (!this.batchForm.file || !this.batchForm.file.raw) {
                this.$message.error('请先选择压缩包文件')
                return;
            }
            this.$refs.batchForm.validate(valid => {
                if(!valid) return;
                this.loading = true;

                this.batchForm.file.raw.arrayBuffer().then(arrayBuffer => {
                    const uint8 = new Uint8Array(arrayBuffer);
                    const files = unzipSync(uint8);
                    const processedFiles = {};
                    const promises = [];
                    Object.entries(files).forEach(([filename, data]) => {
                        if (filename.startsWith('__MACOSX/') || filename.endsWith('.DS_Store') || filename.startsWith('._')) return
                        if (/\.mp4$/i.test(filename)) {
                            const blob = new Blob([data], { type: 'video/mp4' });
                            const p = this.validateAnimationFile(blob, filename).then(() => {
                                processedFiles[filename] = data;
                            });
                            promises.push(p);
                            return;
                        }
                        if (!/\.(png|jpe?g)$/i.test(filename)) return
                        const blob = new Blob([data], { type: 'image/jpeg' });
                        const originalSizeKB = data.byteLength / 1024;              
                        console.log(`${filename} 原始大小: ${originalSizeKB.toFixed(2)} KB`);
                        const p = this.getImageDimensions(blob).then(({ width, height }) => {
                            if (width !== 2048 || height !== 2048) {
                                throw new Error(`文件 ${filename} 分辨率必须为2048*2048，当前为${width}*${height}`);
                            }
                            return imageCompression(blob, {
                                maxWidthOrHeight: 2048,
                                useWebWorker: true,
                                fileType: 'image/webp',
                                initialQuality: 0.7
                            }).then(compressedFile => {
                                const compressedSizeKB = compressedFile.size / 1024;
                                console.log(`${filename} 压缩后大小: ${compressedSizeKB.toFixed(2)} KB`);

                                return compressedFile.arrayBuffer().then(buf => {
                                    processedFiles[filename.replace(/\.(png|jpe?g)$/i, '.webp')] = new Uint8Array(buf);
                                });
                            });
                        });
                        promises.push(p);
                    });

                    Promise.all(promises).then(() => {
                        const zippedBlob = new Blob([zipSync(processedFiles)], { type: 'application/zip' });
                        console.log(`打包 zip 后大小: ${(zippedBlob.size / 1024 / 1024).toFixed(2)} MB`);
                        const formData = new FormData();
                        formData.append('categories', JSON.stringify(this.batchForm.categories));
                        if(this.batchForm.source) formData.append('source', this.batchForm.source);
                        formData.append('module', this.batchForm.module);
                        formData.append('product', JSON.stringify(this.batchForm.product));
                        formData.append('file', zippedBlob, this.batchForm.file.name);
                        axios.post('/cms/v1/batch-image', formData).then(() => {
                            this.batchReset();
                            this.init();
                        }).finally(() => {
                            this.loading = false;
                        });
                    }).catch((error) => {
                        this.$message.error(error?.message || '批量上传文件处理失败');
                        this.loading = false;
                    });
                }).catch(error => {
                    this.$message.error(error.message || '压缩包读取失败');
                    this.loading = false;
                });
            });
        },
        handleChange(file,fileList){
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
            const maxSize = this.maxSize * 1024 * 1024;
            if (file.size > maxSize) {
                this.$message.error(`文件大小不能超过${this.maxSize}MB！`);
                this.fileList = [];
                return;
            }
            this.fileList = fileList;
            this.batchForm.file = file;
        },
        handleExceed(){
            this.$message.warning('只能上传一个文件，请先删除当前文件再上传新文件')
        },
        handleRemove(){
            this.fileList = fileList;
            this.batchForm.file = null;
        },
        async confirmImageDeletion(ids) {
            const res = await axios.post('/cms/v1/image/daily-references', {ids});
            const referenceMap = res.data.data.referenceMap;
            const dates = Object.values(referenceMap)
                .reduce((all, references) => all.concat(references), [])
                .map(reference => reference.date);
            const message = dates.length
                ? `以下 Daily 已使用所选图片：${dates.join('、')}。继续删除会同时删除这些 Daily 排期，方便重新配置新图片。确定继续吗？`
                : '确定要删除所选图片吗？';
            await ElMessageBox.confirm(message, '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            });
        },
        async remove(row) {
            try {
                await this.confirmImageDeletion([row.id]);
                this.loading = true;
                await axios.delete(`/cms/v1/image/${row.id}`);
                this.data.splice(this.data.indexOf(row), 1);
            } catch (_) {
                // The confirmation dialog is also rejected when the user cancels.
            } finally {
                this.loading = false;
            }
        },
        async batchDelete(){
            try {
                await this.confirmImageDeletion(this.idList);
                this.loading = true;
                await axios.post(`/cms/v1/batch-delete`, {ids: this.idList});
                this.init();
            } catch (_) {
                this.loading = false;
            }
        },
        handleSelectionChange(val) {
            this.idList = val.map(item=>item.id);
        }
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>

</style>
